import { render, staticRenderFns } from "./BasicDataViewTypesConfigComponent.vue?vue&type=template&id=1df8de52&"
import script from "./BasicDataViewTypesConfigComponent.vue?vue&type=script&lang=js&"
export * from "./BasicDataViewTypesConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports